
export const Solutions = [
    {
        id: "cart_abandonment",
        src: "/solutions/shopify-cart-abandonment-solutions",
        title: "Store Credit E-Wallet",
        description: "Your store's own currency. Issue and manage credit balances natively on Shopify or via API — no banks, no friction, full control.",
        bg: "bg-teal-50", accent: "text-teal-600", customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-teal-100 text-teal-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ccfbf1"/>
                <rect x="12" y="18" width="32" height="22" rx="3" fill="#0f766e" opacity="0.5"/>
                <rect x="12" y="22" width="32" height="6" fill="#0f766e" opacity="0.3"/>
                <circle cx="36" cy="32" r="4" fill="#14b8a6"/>
                <rect x="16" y="32" width="10" height="2" rx="1" fill="white" opacity="0.6"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                <div className="flex items-center justify-between py-2 border-b border-gray-100">
                    <span className="text-xs text-gray-500">Customer wallet</span>
                    <span className="text-xs font-semibold text-teal-700">$84.50</span>
                </div>
                <div className="flex items-center justify-between py-2 border-b border-gray-100">
                    <span className="text-xs text-gray-500">Last issued</span>
                    <span className="text-xs font-medium text-gray-800">2 hrs ago</span>
                </div>
                <div className="flex items-center justify-between py-2 border-b border-gray-100">
                    <span className="text-xs text-gray-500">Status</span>
                    <span className="text-xs bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full">Active</span>
                </div>
                <div className="flex items-center justify-between py-2">
                    <span className="text-xs text-gray-500">Source</span>
                    <span className="text-xs text-gray-400">Shopify + API</span>
                </div>
            </div>
        ),
    },
    {
        id: "cashback",
        src: "/solutions/shopify/cashback/free-shopify-cashback-app",
        title: "Cashback",
        description: "Automatically return a percentage of every purchase as store credit. It feels like a premium reward and guarantees customers come back to spend it.",
        bg: "bg-amber-50", accent: "text-amber-500", customTailwind: "col-span-6 lg:col-span-4",
        badge: "bg-amber-100 text-amber-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#fef3c7"/>
                <circle cx="28" cy="28" r="13" fill="#f59e0b" opacity="0.4"/>
                <path d="M28 18v2M28 34v2M22 28h-2M36 28h2" stroke="#92400e" strokeWidth="2" strokeLinecap="round"/>
                <path d="M25 25h6v3a3 3 0 01-6 0v-3z" fill="#f59e0b" opacity="0.8"/>
                <path d="M24 22h8" stroke="#92400e" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-3 gap-2">
                    {[["3%", "Cashback rate"], ["$1,240", "Issued this month"], ["89%", "Redemption rate"]].map(([val, label]) => (
                        <div key={label} className="bg-amber-50 rounded-xl p-2 text-center">
                            <p className="text-sm font-bold text-amber-700">{val}</p>
                            <p className="text-xs text-gray-500">{label}</p>
                        </div>
                    ))}
                </div>
                <div className="flex items-center justify-between py-2 border-b border-gray-100">
                    <span className="text-xs text-gray-500">Jordan M. — Order #4421</span>
                    <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">+$6.30 credit</span>
                </div>
                <div className="flex items-center justify-between py-2">
                    <span className="text-xs text-gray-500">Priya S. — Order #4418</span>
                    <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">+$14.70 credit</span>
                </div>
            </div>
        ),
    },
    {
        id: "memberships",
        src: "/solutions/shopify/cashback/shopify-cashback-vs-discounts",
        title: "Memberships",
        description: "Give subscribers something worth paying for. Drop store credit into member wallets monthly or on milestones — so there's always a reason to stay.",
        bg: "bg-purple-50", accent: "text-violet-500", customTailwind: "col-span-6 lg:col-span-3",
        badge: "bg-violet-100 text-violet-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ede9fe"/>
                <circle cx="28" cy="22" r="7" fill="#7c3aed" opacity="0.7"/>
                <path d="M14 42c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.4"/>
                <path d="M34 18l2 2-2 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Gold members", "$20 / month"], ["Silver members", "$10 / month"], ["Next drop", "May 1, 2026"], ["Active subscribers", "348"]].map(([label, val]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        <span className="text-xs font-medium text-gray-800">{val}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "store_credit_crm",
        src: "/solutions/shopify/cashback/shopify-cashback-examples",
        title: "Store Credit CRM",
        description: "See every customer's balance, history, and behaviour in one place. Segment by credit amount, activity, or redemption rate and act on it instantly.",
        bg: "bg-blue-50", accent: "text-sky-500", customTailwind: "col-span-6 lg:col-span-3",
        badge: "bg-sky-100 text-sky-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#e0f2fe"/>
                <rect x="12" y="16" width="32" height="6" rx="2" fill="#0ea5e9" opacity="0.8"/>
                <rect x="12" y="26" width="32" height="4" rx="2" fill="#0ea5e9" opacity="0.5"/>
                <rect x="12" y="34" width="20" height="4" rx="2" fill="#0ea5e9" opacity="0.3"/>
                <circle cx="40" cy="36" r="5" fill="#0ea5e9"/>
                <path d="M38 36h4M40 34v4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                <div className="flex justify-between pb-2 border-b border-gray-100">
                    <span className="text-xs text-gray-400">Customer</span>
                    <span className="text-xs text-gray-400">Balance</span>
                    <span className="text-xs text-gray-400">Last active</span>
                </div>
                {[["Sarah K.", "$120.00", "Today", "bg-green-100 text-green-700"], ["Marcus L.", "$42.50", "3 days ago", "bg-amber-100 text-amber-700"], ["Anika R.", "$0.00", "Inactive", "bg-red-100 text-red-700"]].map(([name, bal, when, cls]) => (
                    <div key={name} className="flex items-center justify-between py-1.5 border-b border-gray-50 last:border-0">
                        <span className="text-xs text-gray-700 w-16">{name}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>{bal}</span>
                        <span className="text-xs text-gray-400">{when}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "refund_facilitation",
        src: "/solutions/shopify/no-more-chargebacks",
        title: "Refund Facilitation",
        description: "Stop letting refunds bleed revenue. Offer store credit at the point of return — the sale stays on your books and the customer stays in your store.",
        bg: "bg-red-50", accent: "text-rose-500", customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-rose-100 text-rose-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ffe4e6"/>
                <rect x="14" y="18" width="28" height="20" rx="3" fill="#f43f5e" opacity="0.4"/>
                <path d="M22 28h12M22 28l4-4M22 28l4 4" stroke="#f43f5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="18" y="40" width="20" height="3" rx="1.5" fill="#f43f5e" opacity="0.3"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Order #3847", "Refund request", "bg-red-100 text-red-700"], ["Original amount", "$65.00", null], ["Credit issued", "$65.00", "text-teal-600"], ["Cash out", "$0.00", null]].map(([label, val, cls]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        {cls?.includes("bg-") ? <span className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>{val}</span> : <span className={`text-xs font-medium ${cls || "text-gray-800"}`}>{val}</span>}
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "reviews_referrals_loyalty",
        src: "/solutions/shopify/inventory-liquidation",
        title: "Reviews, Referrals, and Loyalty Program",
        description: "Reward the actions that actually grow your business. Give store credit for reviews, referrals, and loyalty milestones — real incentives, no discounting required.",
        bg: "bg-green-50", accent: "text-emerald-500", customTailwind: "col-span-6 lg:col-span-4",
        badge: "bg-emerald-100 text-emerald-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#d1fae5"/>
                <polygon points="28,12 31,22 42,22 33,28 36,38 28,32 20,38 23,28 14,22 25,22" fill="#10b981" opacity="0.8"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-3 gap-2">
                    {[["$5", "Per review"], ["$15", "Per referral"], ["$25", "At 500 pts"]].map(([val, label]) => (
                        <div key={label} className="bg-green-50 rounded-xl p-2 text-center">
                            <p className="text-sm font-bold text-green-700">{val}</p>
                            <p className="text-xs text-gray-500">{label}</p>
                        </div>
                    ))}
                </div>
                <div className="flex items-center justify-between py-2 border-b border-gray-100">
                    <span className="text-xs text-gray-500">Lena B. left a review</span>
                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">+$5 credit</span>
                </div>
                <div className="flex items-center justify-between py-2">
                    <span className="text-xs text-gray-500">Tom R. referred a friend</span>
                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">+$15 credit</span>
                </div>
            </div>
        ),
    },
    {
        id: "scheduled_recurring",
        title: "Scheduled Recurring Store Credit",
        description: "Set it and forget it. Drop credit into customer wallets on whatever cadence suits your business — quietly building habit and driving return visits on autopilot.",
        bg: "bg-amber-50", accent: "text-amber-500", customTailwind: "col-span-6 lg:col-span-3",
        badge: "bg-amber-100 text-amber-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#fef3c7"/>
                <rect x="14" y="14" width="28" height="28" rx="4" fill="#f59e0b" opacity="0.3"/>
                <rect x="14" y="18" width="28" height="6" fill="#f59e0b" opacity="0.5"/>
                <rect x="20" y="14" width="3" height="6" rx="1.5" fill="#92400e"/>
                <rect x="33" y="14" width="3" height="6" rx="1.5" fill="#92400e"/>
                <circle cx="22" cy="32" r="2" fill="#f59e0b"/>
                <circle cx="28" cy="32" r="2" fill="#f59e0b"/>
                <circle cx="34" cy="32" r="2" fill="#f59e0b" opacity="0.4"/>
                <circle cx="22" cy="38" r="2" fill="#f59e0b" opacity="0.4"/>
                <circle cx="28" cy="38" r="2" fill="#f59e0b" opacity="0.6"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Frequency", "Monthly", "bg-amber-100 text-amber-700"], ["Amount per drop", "$10.00", null], ["Next run", "May 1, 2026", null], ["Recipients", "1,204 customers", null]].map(([label, val, cls]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        {cls ? <span className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>{val}</span> : <span className="text-xs font-medium text-gray-800">{val}</span>}
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "paid_ads_promotions",
        title: "Paid Ads & Promotional Campaigns",
        description: "Run promotions that actually stick. Offer store credit as the reward instead of blanket discounts — it converts browsers into buyers and locks in a return visit.",
        bg: "bg-purple-50", accent: "text-violet-500", customTailwind: "col-span-6 lg:col-span-3",
        badge: "bg-violet-100 text-violet-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ede9fe"/>
                <path d="M14 36l8-10 6 6 6-8 8 12" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.5"/>
                <circle cx="38" cy="18" r="6" fill="#7c3aed" opacity="0.8"/>
                <path d="M36 18h4M38 16v4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Campaign", "Spring Drop 2026", null], ["Trigger", "Spend $75, get $10 credit", null], ["Claimed", "834 customers", "bg-violet-100 text-violet-700"], ["Revenue retained", "$8,340", "text-teal-600"]].map(([label, val, cls]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        {cls?.includes("bg-") ? <span className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>{val}</span> : <span className={`text-xs font-medium ${cls || "text-gray-800"}`}>{val}</span>}
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "customer_support_goodwill",
        title: "Customer Support and Goodwill Gestures",
        description: "Something went wrong — it happens. The fastest way to turn a frustrated customer into a loyal one is to make it right, immediately. Issue store credit on the spot before it becomes a chargeback or a bad review.",
        bg: "bg-teal-50", accent: "text-teal-500", customTailwind: "col-span-6 lg:col-span-6",
        badge: "bg-teal-100 text-teal-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ccfbf1"/>
                <path d="M14 22a4 4 0 014-4h20a4 4 0 014 4v14a4 4 0 01-4 4H26l-8 4v-4h-4a4 4 0 01-4-4V22z" fill="#14b8a6" opacity="0.5"/>
                <path d="M22 30l4 4 8-8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-3 gap-2">
                    {[["94%", "Disputes resolved"], ["$0", "Chargeback fees"], ["2 min", "Avg resolution"]].map(([val, label]) => (
                        <div key={label} className="bg-teal-50 rounded-xl p-2 text-center">
                            <p className="text-sm font-bold text-teal-700">{val}</p>
                            <p className="text-xs text-gray-500">{label}</p>
                        </div>
                    ))}
                </div>
                {[["Delayed shipment — Chris M.", "$15 goodwill credit"], ["Damaged item — Fatima A.", "$40 credit issued"], ["Wrong size — Raj P.", "$22 credit issued"]].map(([label, val]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        <span className="text-xs bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full">{val}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "internal_teams",
        title: "Internal Teams Store Credit",
        description: "Issue credit to your own team for staff perks, allowances, or product testing. Fully tracked, fully controlled — no expense reports, no overhead.",
        bg: "bg-gray-50", accent: "text-gray-500", customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-gray-100 text-gray-600",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#f3f4f6"/>
                <circle cx="20" cy="22" r="6" fill="#6b7280" opacity="0.6"/>
                <circle cx="36" cy="22" r="6" fill="#6b7280" opacity="0.3"/>
                <path d="M8 42c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.5"/>
                <path d="M32 42c0-6.627 5.373-12 12-12" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.3"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Support team", "$50 / mo"], ["Founders", "Unlimited"], ["Total issued", "$3,200"]].map(([label, val]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        <span className="text-xs font-medium text-gray-800">{val}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "gift_cards",
        title: "Gift Card / Voucher Programs",
        description: "Let customers gift your store to someone else. Digital gift cards backed by store credit bring in new buyers who already have money ready to spend.",
        bg: "bg-amber-50", accent: "text-amber-500", customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-amber-100 text-amber-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#fef3c7"/>
                <rect x="12" y="20" width="32" height="20" rx="3" fill="#f59e0b" opacity="0.4"/>
                <rect x="12" y="20" width="32" height="8" rx="3" fill="#f59e0b" opacity="0.7"/>
                <line x1="28" y1="20" x2="28" y2="40" stroke="#fef3c7" strokeWidth="1.5"/>
                <path d="M28 20c0 0-5-6 0-6s0 6 0 6" stroke="#92400e" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
                <path d="M28 20c0 0 5-6 0-6s0 6 0 6" stroke="#92400e" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Voucher #GC-8821", "$50.00", null], ["Redeemed by", "New customer", null], ["Status", "Claimed", "bg-green-100 text-green-700"]].map(([label, val, cls]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        {cls ? <span className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>{val}</span> : <span className="text-xs font-medium text-gray-800">{val}</span>}
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "b2b_account_management",
        title: "B2B Account Management",
        description: "For business buyers, store credit works like a house account. Pre-load a balance, let them order against it — no payment friction, no invoice chasing.",
        bg: "bg-blue-50", accent: "text-sky-500", customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-sky-100 text-sky-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#e0f2fe"/>
                <rect x="12" y="18" width="32" height="22" rx="3" fill="#0ea5e9" opacity="0.3"/>
                <rect x="18" y="14" width="10" height="8" rx="2" fill="#0ea5e9" opacity="0.7"/>
                <rect x="16" y="28" width="8" height="7" rx="1" fill="#0ea5e9" opacity="0.6"/>
                <rect x="28" y="28" width="8" height="7" rx="1" fill="#0ea5e9" opacity="0.3"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-2">
                {[["Acme Corp", "$2,000 credit", "bg-sky-100 text-sky-700"], ["Last order", "Apr 18, 2026", null], ["Remaining", "$1,340.00", "text-sky-600"]].map(([label, val, cls]) => (
                    <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                        <span className="text-xs text-gray-500">{label}</span>
                        {cls?.includes("bg-") ? <span className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>{val}</span> : <span className={`text-xs font-medium ${cls || "text-gray-800"}`}>{val}</span>}
                    </div>
                ))}
            </div>
        ),
    },
];